(() => {
  'use strict';

  const desktopQuery = window.matchMedia('(min-width: 990px)');
  const interactiveSelector = [
    'button',
    'input',
    'select',
    'textarea',
    'label',
    'form',
    '[role="button"]',
    '[data-quick-add-btn]',
    '[data-add-to-cart]',
    '[data-grid-swatch-form]',
    '[data-sibling-fieldset]',
    '[data-sibling-link]',
    '[data-quick-add-modal]',
    'grid-swatch',
    'product-siblings',
    '.radio__fieldset',
    '.selector-wrapper__actions',
    '.flickity-button',
    '.slider__button'
  ].join(',');

  let pointerStart = null;

  function isHomepageDesktop() {
    return desktopQuery.matches && document.body.classList.contains('template-index');
  }

  function getCard(target) {
    return target instanceof Element ? target.closest('[data-grid-item]') : null;
  }

  function isInteractive(target) {
    return target instanceof Element && Boolean(target.closest(interactiveSelector));
  }

  window.addEventListener('pointerdown', function (event) {
    pointerStart = null;

    if (!isHomepageDesktop() || event.button !== 0 || isInteractive(event.target)) return;

    const card = getCard(event.target);
    if (!card) return;

    pointerStart = {
      card: card,
      x: event.clientX,
      y: event.clientY
    };
  }, true);

  window.addEventListener('pointercancel', function () {
    pointerStart = null;
  }, true);

  window.addEventListener('click', function (event) {
    const start = pointerStart;
    pointerStart = null;

    if (!start || !isHomepageDesktop() || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (isInteractive(event.target)) return;

    const card = getCard(event.target);
    if (!card || card !== start.card) return;

    const movement = Math.hypot(event.clientX - start.x, event.clientY - start.y);
    if (movement > 8) return;

    const link = card.querySelector('a.product-link[href]');
    if (!link || !link.href) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(link.href);
  }, true);
})();
